import { isValidEmail } from "@brazilian-utils/brazilian-utils";

class EmailUtils {
  public isValidEmail(email: string) {
    return isValidEmail(email);
  }
}

export const emailUtils = new EmailUtils();
